import { SourcingChannelStatus, SourcingService } from 'api-clients/monolith';

import { DateRangeFilter } from '@/contexts/table-context';

type CampaignsMetricsQueryParams = {
  search?: string;
  channelIds?: string[];
  statuses?: string[];
  positionIds?: string[];
  locationIds?: string[];
  brandIds?: string[];
  dateRange?: DateRangeFilter;
};

/**
 * The openings[] filter is intentionally omitted — no UI in the Filters bar
 * surfaces it today.
 */
export function getCampaignsMetrics(params: CampaignsMetricsQueryParams = {}) {
  return SourcingService.getInternalApiSourcingCampaignsMetrics(
    params.dateRange?.preset,
    params.dateRange?.startDate,
    params.dateRange?.endDate,
    params.channelIds,
    params.statuses as SourcingChannelStatus[] | undefined,
    params.positionIds,
    params.locationIds,
    params.brandIds,
    undefined,
    params.search,
  );
}
